import type { AppFrontendPayload as App } from "@calcom/types/App";

import { AppCard } from "./AppCard";
import { Slider } from "./Slider";

const FEATURED_SLUGS = ["schedly-payments", "supportly", "zignature"];

export const FeaturedAppsSlider = <T extends App>({ items }: { items: T[] }) => {
  const featured = items.filter((app) => FEATURED_SLUGS.includes(app.slug));
  if (featured.length === 0) return null;

  if (featured.length <= 3) {
    return (
      <div className="mb-2">
        <h2 className="text-emphasis mt-0 pb-3 text-base font-semibold leading-none">Featured</h2>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
          {featured.map((app) => (
            <AppCard key={app.name} app={app} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <Slider<T>
      title="Featured"
      items={featured}
      itemKey={(app) => app.name}
      options={{
        perView: 3,
        breakpoints: {
          768: {
            perView: 1,
          },
        },
      }}
      renderItem={(app) => <AppCard app={app} />}
    />
  );
};
